import React, { FC } from 'react'

import styled, { css } from 'styled-components'

import { Box } from '@style-port/roov-ui-components-react'

const Container = styled(Box)<{ $showShadow: boolean }>`
  ${({ $showShadow }) =>
    $showShadow &&
    css`
      box-shadow: 0 5px 20px rgba(122, 137, 160, 0.1);
    `};
`

type Props = {
  padding?: string
  borderRadius?: string
  showShadow?: boolean
  cardType?: 'primary' | 'secondary'
  children: React.ReactNode
  onClick?: (event: React.MouseEvent) => void
  className?: string
}

export const Card: FC<Props> = ({
  padding,
  borderRadius = '--s-2',
  showShadow = false,
  cardType = 'primary',
  children,
  onClick,
  className,
}) => {
  return (
    <Container
      padding={padding}
      borderRadius={borderRadius}
      $showShadow={showShadow}
      onClick={onClick}
      className={`tw-bg-surface-${cardType} ${className}`}
    >
      {children}
    </Container>
  )
}
